import { PublicImages } from "../../../publicImages";
import * as S from "./styled";

const Donio = () => {
  return (
    <S.DonioSuperWrapper>
      <S.DonioWrapper>
        <S.DonioImage src={PublicImages.donio} alt="donio" />
        <S.DonioTitle>
          Speciální kořárek a rehabilitační pobyt pro Kristianka
        </S.DonioTitle>
        <S.Text>
          Kristiánek je usměvaný jedenáctiletý chlapec, který statečně čelí
          vážným zdravotním potížím. Společně s maminkou nyní potřebují pomoc s
          pořízením speciálního kočárku a financováním rehabilitačního pobytu.
          Každý příspěvek jim pomůže zlepšit kvalitu života.
        </S.Text>
        <S.DonioLink
          href="https://donio.cz/specialni-kocarek-a-rehabilitacni-pobyt-pro-kristianka"
          target="_"
        >
          Přečtěte si celý příběh a podpořte ho na webu Donio
        </S.DonioLink>
      </S.DonioWrapper>
    </S.DonioSuperWrapper>
  );
};

export default Donio;
